module.exports = "<script type=\"text/html\" id=\"survey-progress\">\n    <div data-bind=\"css: css.progress\">\n        <div data-bind=\"css: css.progressBar, style:{width: koProgress() + '%'}\"\n            role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n            <span data-bind=\"text:koProgressText, css: css.progressText + ' ' + css.progressTextInBar\"></span>\n        </div>\n        <span data-bind=\"text:koProgressText, css: css.progressText + ' ' + css.progressTextUnderBar\"></span>\n    </div>\n</script>";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/progress.html
// module id = 78
// module chunks = 0